import { FC, ReactElement, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { LiveNotificationsService, SendChallengeLiveNotificationRequestSchema } from "../sdk"
import Input from "./Input"
import Button from "./Button"
import useError from "../hooks/useError"
import { toast } from "react-toastify"
import Textarea from "./Textarea"

type Props = {
  challengeId: number
  onSubmit?(): void
}

const Form: FC<Props> = ({ challengeId, onSubmit: onSubmitProp }) => {
  const { control, handleSubmit, formState } = useForm<SendChallengeLiveNotificationRequestSchema>()
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(false)

  const { handleError } = useError()

  const onSubmit = async({ title, description }: SendChallengeLiveNotificationRequestSchema): Promise<void> => {
    try {
      setSubmitDisabled(true)
      await LiveNotificationsService.sendChallengeLiveNotification({
        challengeId,
        title,
        description
      })
      toast.success("Notifica inviata con successo")
    } catch (err) {
      handleError(err)
    }
    if (onSubmitProp) {
      onSubmitProp()
    }
    setSubmitDisabled(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        name="title"
        control={control}
        defaultValue=""
        rules={{ required: "Campo obbligatorio" }}
        render={({ field: { value, onChange } }): ReactElement => {
          return (
            <Input
              onChange={onChange}
              value={value}
              type="text"
              error={formState.errors.title?.message}
              placeholder="Titolo"
              className="mb-2"
            />
          )
        }}
      />

      <Controller
        name="description"
        control={control}
        defaultValue=""
        rules={{ required: "Campo obbligatorio" }}
        render={({ field: { value, onChange } }): ReactElement => {
          return (
            <Textarea
              onChange={onChange}
              value={value}
              type="text"
              error={formState.errors.description?.message}
              placeholder="Descrizione"
            />
          )
        }}
      />

      <Button type="submit" className="mt-4" disabled={submitDisabled}>Invia</Button>
    </form>
  )
}

export default Form